import { createSlice } from '@reduxjs/toolkit';

const mainReducer = createSlice({
  name: 'mainReducer',
  initialState: {
    isOpenSearchBar: false,
    isOpenAuthModal: false,
    isOpenServiceModal: { isOpen: false, data: null, setter: null },
    isOpenPostModal: { isOpen: false, data: null, func: null },
    isOpenUserEditModal: false,
    isOpenUserContactsModal: false,
    isOpenSupportModal: false,
    isOpenResendingModal: { isOpen: false, id: null, type: null, func: null },
    usersForResending: [],
    resendingText: '',
    isOpenUserReadersModal: false,
    isOpenImageCropModal: { isOpen: false, file: null, setter: null },
    isFullscreenPic: false,
    isNewMessage: false,
    isNewNotification: false,
    userNotifications: [],
    isOpenDeleteModal: { isOpen: false, text: '', func: null, id: null },
    isOpenParcelDoneModal: { isOpen: false, serviceName: '', seller: '', func: null },
    isOpenDeleteAttentionModal: false,
    isOpenCancelModal: { isOpen: false, func: null, id: null },
    isOpenServiceOrderModal: { isOpen: false, data: null },
    isOpenTTNModal: { isOpen: false, func: null },
    userData: {},
    boosters: 0,
    premiumSubscription: null,
    userSubscribers: [],
    userSubscriptions: [],
    userSavedPosts: [],
    userSavedServices: [],
    blockedUsers: [],
    usersWhoBlocked: [],
    mutedUsers: [],
    savedCards: [],
    socketMsg: null,
    socketInfoMsg: null,
    stompClient: null,
    isOpenDeleteAccModal: false,
    isOpenChangeMailModal: false,
    isOpenDeleteAccAttentionModal: false,
    isOpenEnable2FAModal: false,
    isOpenComplainModal: { isOpen: false, func: null },
    isOpenPremiumCancelModal: false,
    isOpenPremiumModal: false,
    isOpenBoostersModal: false,
    isOpenAccountPromoteModal: false,
    isOpenServicePromoteModal: {
      isOpen: false,
      id: null,
      title: null,
      setter: null
    },
    isOpenBlockDeleteModal: {
      isOpen: false,
      title: '',
      description: ''
    },
    isOpenReferralModal: { isOpen: false, type: null, userId: null },
    isOpenFreezePremiumModal: false,
    isOpenCalendarModal: { isOpen: false, func: null, id: null, startDate: null },
    isOpenOrderAttentionModal: false,
  },
  reducers: {
    setStompClient: (state, action) => {
      state.stompClient = action.payload;
    },
    setIsNewMessage: (state, action) => {
      state.isNewMessage = action.payload;
    },
    setIsNewNotification: (state, action) => {
      state.isNewNotification = action.payload;
    },
    setUserNotifications: (state, action) => {
      state.userNotifications = action.payload;
    },
    setUsersForResending: (state, action) => {
      state.usersForResending = action.payload;
    },
    setResendingText: (state, action) => {
      state.resendingText = action.payload;
    },
    setSocketMsg: (state, action) => {
      state.socketMsg = action.payload;
    },
    setSocketInfoMsg: (state, action) => {
      state.socketInfoMsg = action.payload;
    },
    setIsOpenSearchBar: (state, action) => {
      state.isOpenSearchBar = action.payload;
    },
    setIsOpenServiceModal: (state, action) => {
      state.isOpenServiceModal = action.payload;
    },
    setIsOpenPostModal: (state, action) => {
      state.isOpenPostModal = action.payload;
    },
    setIsOpenAuthModal: (state, action) => {
      state.isOpenAuthModal = action.payload;
    },
    setIsOpenUserEditModal: (state, action) => {
      state.isOpenUserEditModal = action.payload;
    },
    setIsOpenUserContactsModal: (state, action) => {
      state.isOpenUserContactsModal = action.payload;
    },
    setIsOpenSupportModal: (state, action) => {
      state.isOpenSupportModal = action.payload;
    },
    setIsOpenResendingModal: (state, action) => {
      state.isOpenResendingModal = action.payload;
    },
    setIsOpenUserReadersModal: (state, action) => {
      state.isOpenUserReadersModal = action.payload;
    },
    setIsOpenImageCropModal: (state, action) => {
      state.isOpenImageCropModal = action.payload;
    },
    setIsOpenDeleteModal: (state, action) => {
      state.isOpenDeleteModal = action.payload;
    },
    setIsOpenParcelDoneModal: (state, action) => {
      state.isOpenParcelDoneModal = action.payload;
    },
    setIsOpenDeleteAttentionModal: (state, action) => {
      state.isOpenDeleteAttentionModal = action.payload;
    },
    setIsOpenCancelModal: (state, action) => {
      state.isOpenCancelModal = action.payload;
    },
    setIsOpenServiceOrderModal: (state, action) => {
      state.isOpenServiceOrderModal = action.payload;
    },
    setIsOpenTTNModal: (state, action) => {
      state.isOpenTTNModal = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setUserSubscribers: (state, action) => {
      state.userSubscribers = action.payload;
    },
    setUserSubscriptions: (state, action) => {
      state.userSubscriptions = action.payload;
    },
    setUserSavedPosts: (state, action) => {
      state.userSavedPosts = action.payload;
    },
    setUserSavedServices: (state, action) => {
      state.userSavedServices = action.payload;
    },
    setBlockedUsers: (state, action) => {
      state.blockedUsers = action.payload;
    },
    setUsersWhoBlocked: (state, action) => {
      state.usersWhoBlocked = action.payload;
    },
    setMutedUsers: (state, action) => {
      state.mutedUsers = action.payload;
    },
    setIsOpenFullscreenPicture: (state, action) => {
      state.isFullscreenPic = action.payload;
    },
    setIsOpenDeleteAccModal: (state, action) => {
      state.isOpenDeleteAccModal = action.payload;
    },
    setIsOpenChangeMailModal: (state, action) => {
      state.isOpenChangeMailModal = action.payload;
    },
    setIsOpenDeleteAccAttentionModal: (state, action) => {
      state.isOpenDeleteAccAttentionModal = action.payload;
    },
    setIsOpenEnable2FAModal: (state, action) => {
      state.isOpenEnable2FAModal = action.payload;
    },
    setIsOpenComplainModal: (state, action) => {
      state.isOpenComplainModal = action.payload;
    },
    setIsOpenPremiumCancelModal: (state, action) => {
      state.isOpenPremiumCancelModal = action.payload;
    },
    setIsOpenPremiumModal: (state, action) => {
      state.isOpenPremiumModal = action.payload;
    },
    setPremiumSubscription: (state, action) => {
      state.premiumSubscription = action.payload;
    },

    setIsOpenBoostersModal: (state, action) => {
      state.isOpenBoostersModal = action.payload;
    },
    setBoosters: (state, action) => {
      state.boosters = action.payload;
    },
    setIsOpenAccountPromoteModal: (state, action) => {
      state.isOpenAccountPromoteModal = action.payload;
    },
    setIsOpenServicePromoteModal: (state, action) => {
      state.isOpenServicePromoteModal = action.payload;
    },
    setIsOpenBlockDeleteModal: (state, action) => {
      state.isOpenBlockDeleteModal = action.payload;
    },
    setIsOpenReferralModal: (state, action) => {
      state.isOpenReferralModal = action.payload;
    },
    setIsOpenFreezePremiumModal: (state, action) => {
      state.isOpenFreezePremiumModal = action.payload;
    },
    setIsOpenCalendarModal: (state, action) => {
      state.isOpenCalendarModal = action.payload;
    },
    setSavedCards: (state, action) => {
      state.savedCards = action.payload;
    },
    setIsOpenOrderAttentionModal: (state, action) => {
      state.isOpenOrderAttentionModal = action.payload;
    },
    resetState: (state) => {
      return {
        ...state,
        isOpenSearchBar: false,
        isOpenAuthModal: false,
        isOpenServiceModal: false,
        isOpenPostModal: { isOpen: false, data: null, func: null },
        isOpenUserEditModal: false,
        isOpenUserContactsModal: false,
        isOpenSupportModal: false,
        isOpenResendingModal: { isOpen: false, id: null, type: null, func: null },
        usersForResending: [],
        resendingText: '',
        isOpenUserReadersModal: false,
        isOpenImageCropModal: { isOpen: false, file: null, setter: null },
        isFullscreenPic: false,
        isNewMessage: false,
        isNewNotification: false,
        userNotifications: [],
        isOpenDeleteModal: { isOpen: false, text: '', func: null, id: null },
        isOpenParcelDoneModal: { isOpen: false, serviceName: '', seller: '', func: null },
        isOpenDeleteAttentionModal: false,
        isOpenCancelModal: { isOpen: false, func: null, id: null },
        isOpenServiceOrderModal: { isOpen: false, data: null },
        isOpenTTNModal: { isOpen: false, func: null },
        userData: {},
        boosters: 0,
        premiumSubscription: null,
        userSubscribers: [],
        userSubscriptions: [],
        userSavedPosts: [],
        userSavedServices: [],
        blockedUsers: [],
        usersWhoBlocked: [],
        mutedUsers: [],
        savedCards: [],
        socketMsg: null,
        socketInfoMsg: null,
        stompClient: null,
        isOpenDeleteAccModal: false,
        isOpenChangeMailModal: false,
        isOpenDeleteAccAttentionModal: false,
        isOpenEnable2FAModal: false,
        isOpenComplainModal: { isOpen: false, func: null },
        isOpenPremiumCancelModal: false,
        isOpenPremiumModal: false,
        isOpenBoostersModal: false,
        isOpenAccountPromoteModal: false,
        isOpenServicePromoteModal: {
          isOpen: false,
          id: null,
          title: null,
          setter: null
        },
        isOpenBlockDeleteModal: { isOpen: false, title: '', description: '' },

        isOpenReferralModal: { isOpen: false, type: null, userId: null },
        isOpenFreezePremiumModal: false,
        isOpenCalendarModal: { isOpen: false, func: null, id: null, startDate: null },
        isOpenOrderAttentionModal: false,
      };
    }
  }
});

export const {
  setUserSavedPosts,
  setUserSavedServices,
  setResendingText,
  setUsersForResending,
  setIsOpenFullscreenPicture,
  setIsOpenSearchBar,
  setIsOpenAuthModal,
  setIsOpenPostModal,
  setIsOpenServiceModal,
  setIsOpenUserEditModal,
  setIsOpenUserContactsModal,
  setIsOpenSupportModal,
  setIsOpenResendingModal,
  setIsOpenUserReadersModal,
  setIsOpenImageCropModal,
  setIsOpenDeleteModal,
  setIsOpenCancelModal,
  setIsOpenServiceOrderModal,
  setIsOpenTTNModal,
  setUserData,
  setUserSubscribers,
  setUserSubscriptions,
  setSocketMsg,
  setStompClient,
  setSocketInfoMsg,
  setIsNewMessage,
  setIsOpenDeleteAttentionModal,
  setBlockedUsers,
  setIsOpenDeleteAccModal,
  setIsOpenChangeMailModal,
  setIsNewNotification,
  setUserNotifications,
  setUsersWhoBlocked,
  setMutedUsers,
  setIsOpenDeleteAccAttentionModal,
  setIsOpenEnable2FAModal,
  setIsOpenComplainModal,
  setIsOpenPremiumCancelModal,
  setIsOpenPremiumModal,
  setPremiumSubscription,
  setIsOpenBoostersModal,
  setBoosters,
  setIsOpenBlockDeleteModal,
  setIsOpenAccountPromoteModal,
  setIsOpenServicePromoteModal,
  setIsOpenReferralModal,
  setIsOpenFreezePremiumModal,
  setIsOpenCalendarModal,
  setIsOpenParcelDoneModal,
  setSavedCards,
  setIsOpenOrderAttentionModal,
  resetState
} = mainReducer.actions;
//
export default mainReducer.reducer;
